// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const AppInfoModalLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-appInfoModal" */ "../presentational/appInfoModal/AppInfoModal")).then((bundle)=>{
        return {
            default: bundle.AppInfoModal
        };
    });
export const LazyAppInfoModal = /*#__PURE__*/ lazy(AppInfoModalLazyLoader);
